import React, { Component } from 'react';

class ProductImage extends Component {
  state = {
    loading: true,
    failed: false,
  };

  timeout = null;

  componentDidMount() {
    this.timeout = setTimeout(() => {
      this.setState({ failed: true, loading: false });
    }, 3000);
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  handleImageLoad = () => {
    clearTimeout(this.timeout);
    this.setState({ loading: false });
  };

  handleImageError = () => {
    clearTimeout(this.timeout);
    this.setState({ loading: false, failed: true });
  };

  render() {
    const { uuid, name, useStyle = false } = this.props;
    const { loading, failed } = this.state;

    let imageSrc = '';

    if (loading) {
      imageSrc = '/images/icons/progress.gif';
    } else if (failed) {
      imageSrc = '/images/nophoto.png';
    } else {
      imageSrc = `/api/image/1/${uuid}`;
    }

    const isSpinner = loading;

    return (
      <img
        src={imageSrc}
        alt={name}
        title={name}
        onLoad={isSpinner ? null : this.handleImageLoad}
        onError={isSpinner ? null : this.handleImageError}
        style={useStyle ? { width: "75%", height: "75%" } : undefined}
      />
    );
  }
}

export default ProductImage;
